// These are action types and action creators for the new hub
// (/explore and updated /home January 2017).
// This will fully replace featureAthleteActionCreators.jsx when
// the old /home page is fully removed.

import Services from 'utils/services';

export const FAIL_SEARCH = 'FAIL_SEARCH';
export const FAIL_SEARCH_MORE = 'FAIL_SEARCH_MORE';
export const FAIL_SUGGESTIONS = 'FAIL_SUGGESTIONS';
export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const REQUEST_SEARCH_MORE = 'REQUEST_SEARCH_MORE';
export const REQUEST_SUGGESTIONS = 'REQUEST_SUGGESTIONS';
export const SET_SEARCH_ACTIVE = 'SET_SEARCH_ACTIVE';
export const SUCCESS_SEARCH = 'SUCCESS_SEARCH';
export const SUCCESS_SEARCH_MORE = 'SUCCESS_SEARCH_MORE';
export const SUCCESS_SUGGESTIONS = 'SUCCESS_SUGGESTIONS';
import { setUserFollow } from './actionCreators';

function failSuggestions() {
  return {
    type: FAIL_SUGGESTIONS,
    payload: {
    },
  };
}

function failSearch() {
  return {
    type: FAIL_SEARCH,
    payload: {
    },
  };
}

function requestSuggestions() {
  return {
    type: REQUEST_SUGGESTIONS,
    payload: {
    },
  };
}


function requestSearch() {
  return {
    type: REQUEST_SEARCH,
    payload: {
    },
  };
}

function successSearch(experiment, requestId, results, query, isSearching, dateRequested) {
  return {
    type: SUCCESS_SEARCH,
    payload: {
      experiment,
      requestId,
      results,
      isSearching,
      query,
      dateRequested,
    },
  };
}

function successSuggestions(suggested) {
  return {
    type: SUCCESS_SUGGESTIONS,
    payload: {
      suggested,
    },
  };
}

export function getPublicSuggestions(count = 20) {
  return (dispatch, getState) => {
    const stateWhenRequested = getState();
    if (stateWhenRequested.search.suggestions.isFetching) {
      return;
    }

    const requestData = {
      count,
    };

    dispatch(requestSuggestions(true));

    Services.getPublicSuggestions(requestData)
      .fail(() => dispatch(failSuggestions()))
      .done(responseData => {
        const results = responseData || [];
        const suggestions = results.map((feedUser, index) => ({
          profilePictureUrl: feedUser.imageUrl,
          feedUserId: feedUser.feedUserId,
          followersCount: feedUser.followers,
          friendsCount: 0,
          views: feedUser.views,
          name: feedUser.name,
          searchPosition: index + 1,
          url: feedUser.url,
          isFollowing: feedUser.isFollowing,
        }));

        suggestions.forEach(({ feedUserId, isFollowing }) => {
          const { type: feedUserType, relatedId: feedUserRelatedId } = feedUserId;
          dispatch(setUserFollow(feedUserType, feedUserRelatedId, isFollowing));
        });

        dispatch(successSuggestions(suggestions));
      });
  };
}

export function getUserSuggestions(onlyTeammates, excludedIds, maxScore, count) {
  return dispatch => {
    const requestData = {
      onlyTeammates: onlyTeammates,
      excludeAthleteIds: excludedIds.map(id => id.relatedId),
      maxScore: maxScore,
      count: count,
    };

    dispatch(requestSuggestions(true));

    Services.getSuggestedAthletes(requestData)
      .fail(() => dispatch(failSuggestions()))
      .done(responseData => {
        const results = responseData;

        results.forEach(result => {
          excludedIds.push(result.feedUserId);

          // The `positions` property is already formatted as a string.
          // Most other endpoints return an array of strings, so we'll
          // need to accommodate this with an additional PropType.
          result.formattedPositions = result.positions;
          delete result.positions;
        });

        if (results.length > 0) {
          const newMaxScore = results[results.length - 1].score;

          dispatch(successSuggestions(results, newMaxScore));
        }
      });
  };
}

export function search(searchQuery, date) {
  return dispatch => {
    dispatch(requestSearch());
    if (searchQuery === '') {
      dispatch(successSearch(null, null, [], null, false));
    } else {
      const requestData = {
        query: searchQuery,
        count: 30,
      };

      Services.searchAthlete(requestData)
        .fail(() => dispatch(failSearch()))
        .done(responseData => {
          const {
            experiment,
            requestId,
            results,
          } = responseData;

          dispatch(successSearch(experiment, requestId, results, searchQuery, true, date));

          results.forEach(({ feedUserId, isFollowing }) => {
            const { type: feedUserType, relatedId: feedUserRelatedId } = feedUserId;
            dispatch(setUserFollow(feedUserType, feedUserRelatedId, isFollowing));
          });
        });
    }
  };
}

function failSearchMore(query) {
  return {
    type: FAIL_SEARCH_MORE,
    payload: {
      query,
    },
  };
}


function requestSearchMore() {
  return {
    type: REQUEST_SEARCH_MORE,
    payload: {
    },
  };
}

function successSearchMore(experiment, requestId, results, query, isSearching, dateRequested) {
  return {
    type: SUCCESS_SEARCH_MORE,
    payload: {
      experiment,
      requestId,
      results,
      isSearching,
      query,
      dateRequested,
    },
  };
}

export function searchMore(date) {
  return (dispatch, getState) => {
    const stateWhenRequested = getState();
    if (stateWhenRequested.search.results.inProgress) {
      return;
    }
    if (stateWhenRequested.search.results.findMoreInProgress) {
      return;
    }
    if (stateWhenRequested.search.results.noMoreResults) {
      return;
    }

    dispatch(requestSearchMore());

    const query = stateWhenRequested.search.results.query;
    if (!query) {
      return;
    }

    const requestData = {
      query,
      skip: stateWhenRequested.search.results.results ? stateWhenRequested.search.results.results.length : 0,
      count: 30,
    };

    Services.searchAthlete(requestData)
      .fail(() => dispatch(failSearchMore(query)))
      .done(responseData => {
        const {
          experiment,
          requestId,
          results,
        } = responseData;

        dispatch(successSearchMore(experiment, requestId, results, query, true, date));

        results.forEach(({ feedUserId, isFollowing }) => {
          const { type: feedUserType, relatedId: feedUserRelatedId } = feedUserId;
          dispatch(setUserFollow(feedUserType, feedUserRelatedId, isFollowing));
        });
      });
  };
}

export function setSearchActive(active = true) {
  return {
    type: SET_SEARCH_ACTIVE,
    payload: {
      active: !!active,
    },
  };
}
